import React from 'react';
import { Link } from '@mui/material';
import RowActions from '../components/RowActions';

export const createFilingColumns = ({
  editingRowId,
  saving,
  onStartEdit,
  onCancelEdit,
  onSaveEdit,
  onDeleteClick,
}) => [
  {
    accessorKey: '_id',
    header: 'ID',
    enableEditing: false,
  },
  {
    accessorKey: 'label',
    header: 'Label',
    size: 280,
    enableEditing: true,
  },
  {
    accessorKey: 'url',
    header: 'URL',
    size: 300,
    enableEditing: true,
    Cell: ({ cell, row }) => {
      if (editingRowId === row.original._id) return cell.getValue();
      const url = cell.getValue();
      if (!url) return '';
      return (
        <Link href={url} target="_blank" rel="noopener noreferrer" underline="hover" sx={{ fontSize: '0.875rem' }}>
          {url.length > 60 ? `${url.slice(0, 60)}…` : url}
        </Link>
      );
    },
  },
  {
    accessorKey: 'created_at',
    header: 'Created At',
    size: 180,
    enableEditing: false,
    Cell: ({ cell }) => {
      const value = cell.getValue();
      if (!value) return '';
      return new Date(value).toLocaleString();
    },
  },
  {
    id: 'actions',
    header: 'Actions',
    size: 120,
    enableSorting: false,
    enableColumnFilter: false,
    Cell: ({ row }) => {
      const isEditing = editingRowId === row.original._id;
      return (
        <RowActions
          isEditing={isEditing}
          saving={saving}
          onEdit={() => onStartEdit(row.original)}
          onDelete={() => onDeleteClick(row.original)}
          onSave={() => onSaveEdit(row.original._id)}
          onCancel={onCancelEdit}
        />
      );
    },
  },
];
